module.exports = __webpack_public_path__ + "img/bg-icon.8f78f23b.png";